import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, MinusIcon, TrendingUpIcon } from 'lucide-react';
export function FitSection() {
  return <section className="py-24 bg-cream" data-id="element-1">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-2">
        <div className="grid md:grid-cols-2 gap-12 mb-24" data-id="element-3">
          {/* Who This Is For */}
          <FadeIn data-id="element-4">
            <div className="bg-white p-8 rounded-2xl shadow-sm h-full border-t-4 border-teal" data-id="element-5">
              <h3 className="text-h3 mb-8" data-id="element-6">Para quién es esto</h3>
              <ul className="space-y-4" data-id="element-7">
                {['Mujeres de más de 65 años con diagnóstico de osteopenia o osteoporosis.', 'Personas que sienten inestabilidad o falta de equilibrio al caminar.', 'Quienes quieren fortalecerse pero temen lastimarse en un gimnasio.', 'Mujeres que valoran su independencia y quieren seguir siendo dueñas de su movilidad.'].map((text, i) => <li key={i} className="flex gap-3 items-start" data-id="element-8">
                    <CheckIcon className="w-6 h-6 text-teal flex-shrink-0 mt-1" data-id="element-9" />
                    <span className="text-body" data-id="element-10">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who This Is Not For */}
          <FadeIn delay={0.2} data-id="element-11">
            <div className="bg-white p-8 rounded-2xl shadow-sm h-full border-t-4 border-charcoal/20" data-id="element-12">
              <h3 className="text-h3 mb-8 text-charcoal/60" data-id="element-13">
                Para quién NO es
              </h3>
              <ul className="space-y-4" data-id="element-14">
                {['Personas que buscan rutinas de alta intensidad o culturismo.', 'Quienes no estén dispuestos a dedicar 15 minutos diarios a su salud.', "Personas que buscan soluciones 'mágicas' de una sola noche."].map((text, i) => <li key={i} className="flex gap-3 items-start text-charcoal/70" data-id="element-15">
                    <MinusIcon className="w-6 h-6 text-charcoal/40 flex-shrink-0 mt-1" data-id="element-16" />
                    <span className="text-body" data-id="element-17">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>

        {/* Proof / Believability */}
        <FadeIn data-id="element-18">
          <div className="max-w-3xl mx-auto text-center" data-id="element-19">
            <TrendingUpIcon className="w-12 h-12 text-teal mx-auto mb-6" data-id="element-20" />
            <h2 className="text-h2 mb-6" data-id="element-21">Lo que cambia en 14 días</h2>
            <p className="text-body-lg text-charcoal/80 leading-relaxed" data-id="element-22">
              No verás un cambio en la densidad ósea en una semana, pero
              sentirás algo mucho más importante: la{' '}
              <strong className="text-navy font-bold" data-id="element-23">
                "Fuerza Estructural"
              </strong>
              . Tus piernas se sentirán más firmes bajo tu peso, tu postura será
              más erguida y recuperarás esa confianza mental que te permitía
              caminar sin mirar constantemente al suelo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}